import React, { useEffect, useRef, useState } from "react";
import "./Banking.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const Banking = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const consultationOptions = [
    {
      id: 1,
      title: "Core Banking Systems",
      description:
        "Comprehensive software solutions for efficient banking operations and customer management",
      whatsappMessage:
        "Hello, I'm interested in Core Banking Systems consultation.",
    },
    {
      id: 2,
      title: "Digital Banking Platforms",
      description:
        "Customer-centric digital banking solutions for seamless online and mobile banking experiences",
      whatsappMessage: "Hello, I'm interested in Digital Banking Platforms consultation.",
    },
    {
      id: 3,
      title: "Payment Processing Solutions",
      description: "Secure and efficient payment processing systems for various transaction types",
      whatsappMessage:
        "Hello, I'm interested in Payment Processing Solutions consultation.",
    },
    {
      id: 4,
      title: "Banking Analytics",
      description:
        "Data-driven insights for risk management, customer behavior analysis, and business decisions",
      whatsappMessage:
        "Hello, I'm interested in Banking Analytics consultation.",
    },
    {
      id: 5,
      title: "Fraud Detection Systems",
      description:
        "AI-powered solutions for real-time fraud detection and prevention",
      whatsappMessage:
        "Hello, I'm interested in Fraud Detection Systems consultation.",
    },
    {
      id: 6,
      title: "Blockchain Banking Solutions",
      description: "Distributed ledger technology for secure and transparent banking operations",
      whatsappMessage:
        "Hello, I'm interested in Blockchain Banking Solutions consultation.",
    },
  ];

  const handleButtonClick = () => {
    setShowModal(true);
    setSelectedOption(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleWhatsAppRedirect = () => {
    if (selectedOption) {
      const message = encodeURIComponent(selectedOption.whatsappMessage);
      window.open(`https://wa.me/+919155599968?text=${message}`, "_blank");
      setShowModal(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  return (
    <div className="banking-page">
      <Helmet>
        <title>
          Banking Technology Solutions | Innovative Financial Technology Services
        </title>
        <meta
          name="description"
          content="Explore our comprehensive banking technology solutions including core banking systems, digital banking platforms, payment processing, and analytics solutions."
        />
        <meta
          name="keywords"
          content="banking technology, core banking, digital banking, payment processing, banking analytics, fraud detection, blockchain banking, financial technology, banking software, mobile banking, online banking, banking security, financial services, banking innovation, AI in banking, banking digital transformation, banking CRM, financial analytics, banking compliance, fintech solutions, banking automation, banking cloud solutions, banking data management, banking cybersecurity, open banking, banking APIs, digital wallets, banking integration, financial inclusion, banking customer experience"
        />
      </Helmet>

      {/* Hero Section */}
<section className="banking-hero">
  <div className="banking-hero-content">
    <h1 className="banking-hero-title">
      Revolutionizing{" "}
      <span className="banking-highlight">Digital Banking</span>
    </h1>
    <p className="banking-hero-description">
      We deliver cutting-edge financial technology solutions that transform how banking services are delivered, managed, and experienced. From core banking systems to AI-powered security and blockchain integration.
    </p>
    <div className="banking-hero-buttons">
      <a href="/contact-us">
        <button className="banking-btn banking-btn-primary">
          Start Banking Transformation
        </button>
      </a>
      <button className="banking-btn banking-btn-secondary">
        Explore Solutions
      </button>
    </div>
  </div>
  <div className="banking-hero-visual">
    <div className="banking-financial-tower">
      <div className="banking-tower-floor"></div>
      <div className="banking-tower-floor"></div>
      <div className="banking-tower-floor"></div>
      <div className="banking-tower-entrance"></div>
    </div>
    <div className="banking-data-orb banking-data-orb-1"></div>
    <div className="banking-data-orb banking-data-orb-2"></div>
    <div className="banking-data-orb banking-data-orb-3"></div>
    <div className="banking-currency-flow"></div>
  </div>
</section>

      {/* Services Section */}
      <section className="banking-services">
        <div className="banking-services-header">
          <h2 className="banking-section-title">
            Our Banking Solutions
          </h2>
          <p className="banking-section-subtitle">
            Innovative financial technology services designed to transform your banking operations, enhance customer experiences, and drive growth in the digital finance market.
          </p>
        </div>

        <div className="banking-services-grid">
          {/* Core Banking Card */}
          <div className="banking-service-card">
            <div className="banking-service-icon">
              <div className="banking-icon banking-icon-core"></div>
            </div>
            <h3>Core Banking Systems</h3>
            <p>
              Comprehensive software for efficient banking operations, customer management, and transaction processing.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Account Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Transaction Processing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Loan Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Compliance Reporting</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Operational Efficiency</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">System Uptime</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Digital Banking Card */}
          <div className="banking-service-card">
            <div className="banking-service-icon">
              <div className="banking-icon banking-icon-digital"></div>
            </div>
            <h3>Digital Banking Platforms</h3>
            <p>
              Customer-centric digital banking solutions for seamless online and mobile banking experiences.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Mobile Banking Apps</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Internet Banking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Digital Onboarding</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Biometric Authentication</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">65%</div>
                <div className="stat-label">Digital Adoption</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">45%</div>
                <div className="stat-label">Cost Reduction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Payment Processing Card */}
          <div className="banking-service-card">
            <div className="banking-service-icon">
              <div className="banking-icon banking-icon-payment"></div>
            </div>
            <h3>Payment Processing Solutions</h3>
            <p>
              Secure and efficient payment processing systems for various transaction types and channels.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Real-time Payments</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Cross-border Transactions</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Card Processing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Payment Gateway Integration</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">1.2M</div>
                <div className="stat-label">Transactions/Day</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.95%</div>
                <div className="stat-label">Success Rate</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Fraud Detection Card */}
          <div className="banking-service-card">
            <div className="banking-service-icon">
              <div className="banking-icon banking-icon-fraud"></div>
            </div>
            <h3>Fraud Detection Systems</h3>
            <p>
              AI-powered solutions for real-time fraud detection, prevention, and security management.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Real-time Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Behavioral Analytics</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Machine Learning Models</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Transaction Pattern Analysis</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">92%</div>
                <div className="stat-label">Fraud Detection</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">60%</div>
                <div className="stat-label">False Positives Reduction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Banking Analytics Card */}
          <div className="banking-service-card">
            <div className="banking-service-icon">
              <div className="banking-icon banking-icon-analytics"></div>
            </div>
            <h3>Banking Analytics</h3>
            <p>
              Data-driven insights for risk management, customer behavior analysis, and business decisions.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Risk Assessment</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Customer Segmentation</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Portfolio Analysis</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Predictive Modeling</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">35%</div>
                <div className="stat-label">Risk Reduction</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">28%</div>
                <div className="stat-label">Revenue Growth</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Blockchain Banking Card */}
          <div className="banking-service-card">
            <div className="banking-service-icon">
              <div className="banking-icon banking-icon-blockchain"></div>
            </div>
            <h3>Blockchain Banking Solutions</h3>
            <p>
              Distributed ledger technology for secure, transparent, and efficient banking operations.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Smart Contracts</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Digital Identity</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Cross-border Settlements</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Asset Tokenization</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">70%</div>
                <div className="stat-label">Faster Settlements</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Cost Reduction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Wealth Management Card */}
          <div className="banking-service-card">
            <div className="banking-service-icon">
              <div className="banking-icon banking-icon-wealth"></div>
            </div>
            <h3>Wealth Management Platforms</h3>
            <p>
              Technology solutions for investment management, portfolio tracking, and financial advisory services.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Portfolio Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Robo-advisory</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Investment Analytics</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Goal-based Planning</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">$15B</div>
                <div className="stat-label">Assets Managed</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">25%</div>
                <div className="stat-label">ROI Improvement</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Compliance & Risk Card */}
          <div className="banking-service-card">
            <div className="banking-service-icon">
              <div className="banking-icon banking-icon-compliance"></div>
            </div>
            <h3>Compliance & Risk Management</h3>
            <p>
              Comprehensive solutions for regulatory compliance, risk assessment, and audit management.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Regulatory Reporting</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>KYC/AML Solutions</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Risk Assessment Tools</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Audit Trail Management</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">95%</div>
                <div className="stat-label">Compliance Accuracy</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Time Savings</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>
        </div>

        <div className="banking-services-cta">
          <h3>Ready to transform your banking operations?</h3>
          <p>
            Schedule a free consultation with our banking technology experts to discuss your specific needs.
          </p>
          <div className="services-cta-buttons">
            <div className="banking-consultation-container">
              <button
                className="banking-primary-btn banking-pulse"
                onClick={handleButtonClick}
              >
                Book a Consultation
              </button>

              {showModal && (
                <div className="banking-modal-overlay">
                  <div className="banking-modal-content">
                    <button
                      className="banking-close-btn"
                      onClick={handleCloseModal}
                    >
                      &times;
                    </button>

                    <h2 className="banking-modal-title">
                      Banking Technology Consultation
                    </h2>
                    <p className="banking-modal-subtitle">
                      Select an area you need consultation on:
                    </p>

                    <div className="banking-options-grid">
                      {consultationOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`banking-option-card ${
                            selectedOption?.id === option.id ? "selected" : ""
                          }`}
                          onClick={() => handleOptionSelect(option)}
                        >
                          <h3 className="banking-option-title">
                            {option.title}
                          </h3>
                          <p className="banking-option-desc">
                            {option.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <button
                      className={`banking-whatsapp-btn ${
                        selectedOption ? "active" : ""
                      }`}
                      onClick={handleWhatsAppRedirect}
                      disabled={!selectedOption}
                    >
                      Continue to WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="banking-btn banking-btn-secondary">
              View Case Studies
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="banking-stats">
        <div className="banking-stats-container">
          <div className="banking-stat">
            <h3 className="banking-stat-number" data-count="250">
              250
            </h3>
            <p className="banking-stat-label">Banking Projects</p>
          </div>
          <div className="banking-stat">
            <h3 className="banking-stat-number" data-count="98">
              211
            </h3>
            <p className="banking-stat-label">Client Satisfaction</p>
          </div>
          <div className="banking-stat">
            <h3 className="banking-stat-number" data-count="15">
              11
            </h3>
            <p className="banking-stat-label">Years Experience</p>
          </div>
          <div className="banking-stat">
            <h3 className="banking-stat-number" data-count="50">
              50
            </h3>
            <p className="banking-stat-label">Countries Served</p>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="banking-cta">
        <div className="banking-cta-content">
          <h2>Ready to Transform Your Banking Services?</h2>
          <p>
            Contact us today to discuss how our banking technology expertise can help your institution innovate and grow.
          </p>
          <a href="/contact-us">
            <button className="banking-btn banking-btn-primary banking-btn-large">
              Schedule a Consultation
            </button>
          </a>
        </div>
      </section>

      <Testimonial />
    </div>
  );
};

export default Banking;